export const CODES = {
    L1: {
        id: 1,
        name: 'L1'
    },
    L2: {
        id: 2,
        name: 'L2'
    },
    L3: {
        id: 3,
        name: 'L3'
    },
    L4: {
        id: 4,
        name: 'L4'
    }
}

export const CODE_LEVEL_LOOKUP = {
    1:CODES.L1,
    2:CODES.L2,
    3:CODES.L3,
    4:CODES.L4
}

export const ORDER_STATUS = {
    PENDING: {id:1,name: 'Pending', icon: 'schedule'},
    READY: {id:2,name:'Ready', icon: 'check_circle'},
    AT_FACILITY: {id:3,name:'At Facility', icon: 'location_city'},
    EN_ROUTE: {id:4,name:'En Route', icon: 'local_shipping'},
    DELIVERED: {id:5,name:'Delivered', icon: 'beenhere'},
    VOIDED: {id:6,name:'Voided', icon: 'remove_circle'},
    TRAILERED: {id:7,name:'Trailered', icon: 'archive'}
}

export const ORDER_STATUS_LOOKUP = {
    1:ORDER_STATUS.PENDING,
    2:ORDER_STATUS.READY,
    3:ORDER_STATUS.AT_FACILITY,
    4:ORDER_STATUS.EN_ROUTE,
    5:ORDER_STATUS.DELIVERED,
    6:ORDER_STATUS.VOIDED,
    7:ORDER_STATUS.TRAILERED
}

export const SERVICE_LEVELS = {
    NEXT_DAY: { id: 1, name: 'Next Day' },
    SECOND_DAY: { id: 2, name: '2nd Day' },
    NEXT_AVAILABLE: { id: 3, name: 'Next Available' },
    EXPEDITED: { id: 4, name: 'Expedited' }
}

export const SERVICE_LEVEL_LOOKUP = {
    1: SERVICE_LEVELS.NEXT_DAY,
    2: SERVICE_LEVELS.SECOND_DAY,
    3: SERVICE_LEVELS.NEXT_AVAILABLE,
    4: SERVICE_LEVELS.EXPEDITED
}


// WEBPACK FOOTER //
// ./src/constants/index.js